import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="not-found__card">
        <span className="not-found__code">404</span>
        <h1 className="not-found__title">Página no encontrada</h1>
        <p className="not-found__text">
          La ruta que buscas no existe o fue movida.
        </p>
        <Link to="/" className="not-found__btn">
          Volver al Inicio
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
